import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
import { jsx as e } from "react/jsx-runtime";
import { createContext as t, useState as r, useRef as n, useEffect as o, useContext as s } from "react";
var i = t({}),
  c = function c(_ref) {
    var t = _ref.children,
      r = _ref.menu;
    return e(i.Provider, Object.assign({
      value: r
    }, {
      children: t
    }));
  },
  l = function l(e) {
    var t = 0;
    for (; e;) {
      t += e.offsetTop, e = e.offsetParent;
    }
    return t;
  },
  a = function a() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _e$activeClassName = e.activeClassName,
      t = _e$activeClassName === void 0 ? "active" : _e$activeClassName,
      _e$offset = e.offset,
      s = _e$offset === void 0 ? 0 : _e$offset,
      _e$smooth = e.smooth,
      i = _e$smooth === void 0 ? !1 : _e$smooth,
      _r = r(),
      _r2 = _slicedToArray(_r, 2),
      c = _r2[0],
      a = _r2[1],
      d = n(),
      f = n(new Map()),
      u = n(new Map());
    return o(function () {
      var e = d.current,
        t = f.current;
      if (t.size) {
        var _r3 = function _r3() {
          var r,
            n,
            o = -1 / 0;
          var _iterator = _createForOfIteratorHelper(t.entries()),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var _step$value = _slicedToArray(_step.value, 2),
                _i = _step$value[0],
                _c = _step$value[1];
              var _ref2 = (null == e ? void 0 : e.getBoundingClientRect()) || {},
                _ref2$top = _ref2.top,
                _t = _ref2$top === void 0 ? 0 : _ref2$top,
                _c$getBoundingClientR = _c.getBoundingClientRect(),
                _l = _c$getBoundingClientR.top;
              _l <= 0 + _t + s && _l > o && (o = _l, r = _i), n || (n = _i);
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
          a(r || n);
        };
        return _r3(), window.addEventListener("resize", _r3), e ? (e.addEventListener("scroll", _r3), function () {
          window.removeEventListener("resize", _r3), e.removeEventListener("scroll", _r3);
        }) : (window.addEventListener("scroll", _r3), function () {
          window.removeEventListener("resize", _r3), window.removeEventListener("scroll", _r3);
        });
      }
    }, [s]), o(function () {
      var e = d.current,
        t = f.current,
        r = u.current;
      if (t.size && r.size) {
        var _n = function _n(r) {
          return function (n) {
            n.preventDefault();
            var o = t.get(r);
            if (o && n.target instanceof HTMLElement) if (e) {
              var _e$getBoundingClientR = e.getBoundingClientRect(),
                _t2 = _e$getBoundingClientR.top;
              e.scrollTo({
                behavior: i ? "smooth" : "auto",
                top: l(o) - _t2 - s
              });
            } else window.scrollTo({
              behavior: i ? "smooth" : "auto",
              top: l(o) - s
            });
          };
        };
        var _o = [];
        var _iterator2 = _createForOfIteratorHelper(r.entries()),
          _step2;
        try {
          var _loop = function _loop() {
            var _step2$value = _slicedToArray(_step2.value, 2),
              e = _step2$value[0],
              t = _step2$value[1];
            var r = _n(e);
            t.addEventListener("click", r), _o.push(function () {
              return t.removeEventListener("click", r);
            });
          };
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            _loop();
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
        return function () {
          for (var _i2 = 0, _o2 = _o; _i2 < _o2.length; _i2++) {
            var _e = _o2[_i2];
            _e();
          }
        };
      }
    }, [s, i]), o(function () {
      var e = u.current;
      if (e.size) {
        var _iterator3 = _createForOfIteratorHelper(e.entries()),
          _step3;
        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var _step3$value = _slicedToArray(_step3.value, 2),
              _r4 = _step3$value[0],
              _n2 = _step3$value[1];
            _n2.classList.remove(t), _r4 === c && _n2.classList.add(t);
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      }
    }, [t, c]), {
      activeId: c,
      registerContainer: function registerContainer(e) {
        return d.current = e;
      },
      registerSection: function registerSection(e) {
        return function (t) {
          return f.current.set(e, t);
        };
      },
      registerTrigger: function registerTrigger(e) {
        return function (t) {
          return u.current.set(e, t);
        };
      }
    };
  },
  d = function d() {
    return s(i);
  };
export { c as ActiveMenuProvider, a as useActiveMenu, d as useActiveMenuContext };